import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Button, Spinner, Table } from "react-bootstrap";
import { toast } from "react-toastify";
import NiceModal from "@ebay/nice-modal-react";
import agent from "../../api/agent";
import {
  AccountStationCreateRequest,
  AccountStationResponse,
  AccountStationUpdateRequest,
} from "../../models/user";
import LxCard from "../layout/LxCard";
import LxModal from "../layout/LxModal";
import UserAlertCreateForm from "./UserAlertCreateForm";
import UserAlertUpdateForm from "./UserAlertUpdateForm";

NiceModal.register("create-alert", LxModal);
NiceModal.register("edit-alert", LxModal);

const UserAlertSettings = () => {
  const [alertSettings, setAlertSettings] = useState<
    AccountStationResponse[] | undefined
  >(undefined);

  useEffect(() => {
    const fetchAlertSettings = async () => {
      const loadedSettings = await agent.AccountStations.list();
      setAlertSettings(loadedSettings);
    };

    fetchAlertSettings();
  }, []);

  const fetchAlertSettings = async () => {
    const loadedSettings = await agent.AccountStations.list();
    setAlertSettings(loadedSettings);
  };

  const onAddAlert = async (alert: AccountStationCreateRequest) => {
    try {
      await agent.AccountStations.create([alert]);
      toast.success(`Added alert setting for Station ${alert.StationId}.`);

      await fetchAlertSettings();
    } catch (error) {
      toast.error("Failed to add alert setting.");
    }

    NiceModal.hide("create-alert");
  };

  const updateFormHandler = (alert: AccountStationResponse) => {
    if (alert) {
      NiceModal.show("edit-alert", {
        title: "Edit Station Alert",
        size: "sm",
        children: (
          <UserAlertUpdateForm
            alert={alert}
            updateAlertSetting={onUpdateAlert}
          />
        ),
      });
    }
  };

  const showCreateForm = () => {
    NiceModal.show("create-alert", {
      title: "Add Station Alert",
      size: "sm",
      children: <UserAlertCreateForm addAlertSetting={onAddAlert} />,
    });
  };

  const onUpdateAlert = async (alert: AccountStationUpdateRequest) => {
    try {
      await agent.AccountStations.update([alert]);
      toast.success(`Successfully edited AlertSetting ${alert.Id}.`);

      await fetchAlertSettings();
    } catch (error) {
      toast.error("Failed to edit alert setting.");
    }

    NiceModal.hide("edit-alert");
  };

  const alertSettingDeleteHandler = async (id: number) => {
    try {
      await agent.AccountStations.delete(id.toString());
      toast.success(`Successfully deleted AlertSetting ${id}`);

      await fetchAlertSettings();
    } catch (error) {
      toast.error(`Failed to delete AlertSetting ${id}`);
    }
  };

  return (
    <>
      <LxCard title="Alert Settings">
        {alertSettings && (
          <Table responsive striped hover>
            <thead>
              <tr>
                <th scope="col">Station Id</th>
                <th scope="col">Send E-mail?</th>
                <th scope="col">Send Text?</th>
                <th scope="col">Edit</th>
                <th scope="col">Delete</th>
              </tr>
            </thead>
            <tbody>
              {alertSettings.map((setting) => (
                <tr key={setting.Id}>
                  <td>{setting.StationId}</td>
                  <td>{setting.SendEmail ? "Yes" : "No"}</td>
                  <td>{setting.SendText ? "Yes" : "No"}</td>
                  <td>
                    <Button
                      variant="light"
                      onClick={() => updateFormHandler(setting)}
                    >
                      <FontAwesomeIcon icon="edit" />
                    </Button>
                  </td>
                  <td>
                    <Button
                      variant="light"
                      onDoubleClick={() =>
                        alertSettingDeleteHandler(setting.Id)
                      }
                    >
                      <FontAwesomeIcon icon="trash-alt" />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
        {!alertSettings && <Spinner animation="border" />}
        <Button onClick={() => showCreateForm()}>Add</Button>
      </LxCard>
    </>
  );
};

export default UserAlertSettings;
